// TikTok Pixel browser events — only for real funnel steps; event_id shared with the server Events API for dedup.
const ok = () => typeof window !== "undefined" && window.ttq && window.__nadiaConsent !== false;
const sent = new Set();
export const track = (event, props = {}, eventId) => {
  if (!ok()) return;
  if (eventId) { if (sent.has(eventId)) return; sent.add(eventId); }
  try { window.ttq.track(event, props, eventId ? { event_id: eventId } : undefined); } catch { /* ignore */ }
};
export const trackViewContent = (name) => track("ViewContent", { content_name: name });
export const trackInitiateCheckout = (kind, itemId) => track("InitiateCheckout", { content_id: itemId, content_type: "product", content_name: kind });
export const trackPurchase = (status) => track(status.kind === "subscription" ? "Subscribe" : "Purchase", { value: status.amount, currency: "EUR", content_id: status.item_id, content_type: "product" }, `purchase-${status.session_id}`);
export const trackRegistration = (eventId) => track("CompleteRegistration", {}, eventId);
